<template>
  <div v-if="isShow">
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
      <div
        v-for="(banco, index) in bancos"
        :key="banco.name"
        :class="index === bancos.length - 1 && bancos.length % 2 !== 0 ? 'sm:col-span-2 sm:w-1/2 sm:mx-auto' : ''"
      >
        <div
          @click="copyCBU(banco.cbu)"
          class="w-full flex items-center justify-between p-3 rounded-xl bg-white border shadow-lg my-2 text-dark-gray h-30 text-xs cursor-pointer hover:shadow-xl transition-shadow duration-200"
        >
          <img
            :src="banco.logo"
            loading="lazy"
            class="w-10 h-10 bg-gray-300 rounded-full flex-1-truncate"
          />
          <div class="w-full px-4">
            <div class="font-semibold truncate">{{ banco.name }}</div>
            <div class="text-xs font-extralight">
              CBU: {{ banco.cbu }}
              <br />
              Cuenta: {{ banco.account }}
            </div>
          </div>
          <img src="/icons/copy.svg" loading="lazy" class="w-4 h-4" />
        </div>
      </div>
    </div>
    <p class="text-sm text-center m-2">CUIT: 30-50011757-1</p>

    <!-- Toast notification for copy feedback -->
    <div
      v-if="showToast"
      class="fixed bottom-4 right-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 transition-opacity duration-300"
    >
      CBU copiado al portapapeles
    </div>
  </div>
</template>
<script>
  export default {
    name: "Bancos",
    data() {
      return {
        showToast: false,
        bancos: [
          {
            name: "Galicia",
            cbu: "0070056620000000325255",
            account: "325/2-056/5",
            logo: "GaliciaLogoB.png",
          },
          /* {
          name: "HSBC",
          cbu: "1500015200006503000400",
          account: "0650-30004/0",
          logo: "HSBCLogoB.png",
        }, */
          {
            name: "Macro",
            cbu: "2850528230094157965171",
            account: "352809415796517",
            logo: "MacroLogo.png",
          },
          /* {
            name: "Nación",
            cbu: "0110097620009700217703",
            account: "0970021770 Suc. 2507",
            logo: "NacionLogo.png",
          }, */
          {
            name: "Santander",
            cbu: "0720082320000000483290",
            account: "082-004832/9",
            logo: "SantanderLogo.png",
          },
        ],
      };
    },
    props: {
      isShow: Boolean,
    },
    methods: {
      async copyCBU(cbu) {
        try {
          await navigator.clipboard.writeText(cbu);
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 2000);
        } catch (err) {
          // Fallback for older browsers
          const textArea = document.createElement("textarea");
          textArea.value = cbu;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);

          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 2000);
        }
      },
    },
  };
</script>
